import { ACTIVITY, BODY_FAT, BODY_MASS_INDEX, MUSCLE_MASS, WEIGHT } from "constants/trend-charts";
import { TYPE_PROPS_MAP } from "utilities/trend-chart/type-props-map";
import { Guidelines } from "@sisuwellness/utilities";
import { roundTargetWeightBounds } from "@sisuwellness/utilities/Guidelines/Weight/formatTargetWeightRange";

const getTooltipValues = (type, data) => {
    const { guideline, isUnitMetric, currentValue, datum } = data;

    const props = TYPE_PROPS_MAP[type] || {};

    let unit = props.metricUnit ?? "",
        tooltipValues = {};

    if (!isUnitMetric) unit = props.imperialUnit ? props.imperialUnit.toLowerCase() : unit;

    tooltipValues = { value: currentValue, target: "", unit };

    // A target weight or healthy BMI band is not applicable during pregnancy, so no target is
    // offered for a check recorded then — the measurement still renders, only the goal is
    // withheld. `target: ""` also keeps the target tooltip hidden, since ProgressTooltips gates
    // it on a truthy target.
    if (datum?.isPregnant && (type === BODY_MASS_INDEX || type === WEIGHT)) {
        let value = currentValue;

        if (type === WEIGHT && guideline) {
            value = isUnitMetric ? guideline.setUnitToMetric() : guideline.setUnitToImperial();
        }

        return { ...tooltipValues, value, isPregnant: true };
    }

    switch (type) {
        case WEIGHT: {
            const value = isUnitMetric ? guideline.setUnitToMetric() : guideline.setUnitToImperial();
            // `guideline.targetWeightRange` returns RAW unrounded bounds. Rounding must go
            // through `roundTargetWeightBounds` (the single source of truth shared with
            // `formatTargetWeightRange`) — plain display rounding (e.g. `fixedNumber`) rounds
            // the lower bound down in some cases, landing it just outside the healthy band.
            const rawRange = guideline.targetWeightRange;
            const { lower, upper } = roundTargetWeightBounds(rawRange.lower, rawRange.upper, !isUnitMetric);
            // `target` stays numeric so tooltipPosition() keeps working; `targetRange` carries
            // the band for display. RatingTooltip owns the unit/imperial formatting of both.
            return { ...tooltipValues, value, target: upper, targetRange: { lower, upper }, unit };
        }

        case BODY_MASS_INDEX: {
            // Ethnicity-aware: adjusted populations have a normal band ending below 23, so a
            // fixed target of 24 would sit inside their own elevated band.
            const ethnicity = datum?.nhsEthnicity || datum?.ireEthnicity || null;
            const { lower, upper } = Guidelines.BodyMassIndex.SiSU.healthyBmiRangeForEthnicity(ethnicity);
            return { ...tooltipValues, target: upper, targetRange: { lower, upper } };
        }

        case ACTIVITY:
            return { value: "", target: "", unit: "" };

        case BODY_FAT:
            return { ...tooltipValues, unit: "%" };

        case MUSCLE_MASS:
            return { ...tooltipValues, unit: "%" };

        default:
            return tooltipValues;
    }
};

export default getTooltipValues;
